/* src/components/Contact.tsx */
import React, { useState } from 'react';
import contactStyles from '../styles/ContactPage.module.css';

// Import your image-based icons instead of font icons:
import locationIcon from '../resources/team.png';
import phoneIcon from '../resources/team.png';
import emailIcon from '../resources/team.png';
import hoursIcon from '../resources/team.png';
import twitterIcon from '../resources/team.png';
import facebookIcon from '../resources/team.png';
import linkedinIcon from '../resources/team.png';
import instagramIcon from '../resources/team.png';
import sendIcon from '../resources/team.png';

const Contact: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ name, email, subject, message });
    alert('Message sent successfully!');
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
  };

  return (
    <div className={contactStyles['philo-contact-container']}>
      <header className={contactStyles['philo-contact-header']}>
        <div className={contactStyles['philo-header-overlay']}>
          <h1>Contact the Department of Philosophy</h1>
          <p>We'd love to hear from you</p>
        </div>
      </header>

      <div className={contactStyles['philo-contact-content']}>
        <div className={contactStyles['philo-contact-info']}>
          {/* Get in Touch Card */}
          <div className={contactStyles['philo-contact-card']}>
            <h2>Get in Touch</h2>
            <div className={contactStyles['philo-contact-details']}>
              {/* Location */}
              <div className={contactStyles['philo-contact-item']}>
                <div className={contactStyles['philo-contact-icon']}>
                  <img src={locationIcon} alt="Location" />
                </div>
                <div>
                  <h3>Location</h3>
                  <p>
                    Philosophy Hall, Room 301<br />
                    1200 University Drive<br />
                    Calaisz, CA 94305
                  </p>
                </div>
              </div>
              {/* Phone & Fax */}
              <div className={contactStyles['philo-contact-item']}>
                <div className={contactStyles['philo-contact-icon']}>
                  <img src={phoneIcon} alt="Phone" />
                </div>
                <div>
                  <h3>Phone & Fax</h3>
                  <p>
                    Phone: (555) 123-4567<br />
                    Fax: (555) 123-4568
                  </p>
                </div>
              </div>
              {/* Email */}
              <div className={contactStyles['philo-contact-item']}>
                <div className={contactStyles['philo-contact-icon']}>
                  <img src={emailIcon} alt="Email" />
                </div>
                <div>
                  <h3>Email</h3>
                  <p>
                    General Inquiries: philosophy@ucalaisz.edu<br />
                    Admissions: phil-admissions@ucalaisz.edu<br />
                    Faculty Affairs: phil-faculty@ucalaisz.edu
                  </p>
                </div>
              </div>
              {/* Office Hours */}
              <div className={contactStyles['philo-contact-item']}>
                <div className={contactStyles['philo-contact-icon']}>
                  <img src={hoursIcon} alt="Office Hours" />
                </div>
                <div>
                  <h3>Office Hours</h3>
                  <p>
                    Monday–Friday: 9:00 AM–5:00 PM<br />
                    Saturday–Sunday: Closed
                  </p>
                </div>
              </div>
              {/* Social Links */}
              <div className={contactStyles['philo-contact-item']}>
                <div className={contactStyles['philo-contact-icon']}>
                  <img src={twitterIcon} alt="Social" />
                </div>
                <div>
                  <h3>Connect With Us</h3>
                  <div className={contactStyles['philo-social-links']}>
                    <a href="#" className={contactStyles['philo-social-link']}>
                      <img src={twitterIcon} alt="Twitter" />
                    </a>
                    <a href="#" className={contactStyles['philo-social-link']}>
                      <img src={facebookIcon} alt="Facebook" />
                    </a>
                    <a href="#" className={contactStyles['philo-social-link']}>
                      <img src={linkedinIcon} alt="LinkedIn" />
                    </a>
                    <a href="#" className={contactStyles['philo-social-link']}>
                      <img src={instagramIcon} alt="Instagram" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Department Leadership Card */}
          <div className={`${contactStyles['philo-contact-card']} ${contactStyles['philo-staff-card']}`}>
            <div className={contactStyles['philo-card-header']}>
              <h2>Department Leadership</h2>
              <div className={contactStyles['philo-card-decoration']}></div>
            </div>
            <div className={contactStyles['philo-staff-list']}>
              {[
                {
                  name: 'Dr. Marcus Thorne',
                  role: 'Department Chair',
                  email: 'mthorne@ucalaisz.edu',
                  phone: '(555) 123-4570',
                },
                {
                  name: 'Dr. Elena Rodriguez',
                  role: 'Director of Graduate Studies',
                  email: 'erodriguez@ucalaisz.edu',
                  phone: '(555) 123-4571',
                },
                {
                  name: 'Dr. Benjamin Clarke',
                  role: 'Undergraduate Program Director',
                  email: 'bclarke@ucalaisz.edu',
                  phone: '(555) 123-4572',
                },
              ].map((staff) => (
                <div className={contactStyles['philo-staff-member']} key={staff.email}>
                  <div className={contactStyles['philo-staff-avatar']}></div>
                  <div className={contactStyles['philo-staff-info']}>
                    <h3>{staff.name}</h3>
                    <p>{staff.role}</p>
                    <div className={contactStyles['philo-contact-method']}>
                      <img src={emailIcon} alt="Email" />
                      <span>{staff.email}</span>
                    </div>
                    <div className={contactStyles['philo-contact-method']}>
                      <img src={phoneIcon} alt="Phone" />
                      <span>{staff.phone}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Form & Map */}
        <div className={contactStyles['philo-contact-form-map']}>
          <div className={contactStyles['philo-contact-card']}>
            <div className={contactStyles['philo-card-header']}>
              <h2>Send Us a Message</h2>
              <div className={contactStyles['philo-card-decoration']}></div>
            </div>
            <form onSubmit={handleSubmit} className={contactStyles['philo-contact-form']}>
              {[
                { id: 'name', label: 'Full Name', type: 'text', value: name, setter: setName, placeholder: 'Your name' },
                { id: 'email', label: 'Email Address', type: 'email', value: email, setter: setEmail, placeholder: 'you@example.com' },
                { id: 'subject', label: 'Subject', type: 'text', value: subject, setter: setSubject, placeholder: 'Regarding...' },
              ].map(({ id, label, type, value, setter, placeholder }) => (
                <div className={contactStyles['philo-form-group']} key={id}>
                  <label htmlFor={id}>{label}</label>
                  <input
                    id={id}
                    type={type}
                    value={value}
                    onChange={(e) => setter(e.target.value)}
                    placeholder={placeholder}
                    required
                  />
                </div>
              ))}
              <div className={contactStyles['philo-form-group']}>
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message here..."
                  rows={6}
                  required
                />
              </div>
              <button type="submit" className={contactStyles['philo-submit-button']}>
               Send Message
              </button>
            </form>
          </div>

          <div className={contactStyles['philo-contact-card']}>
            <div className={contactStyles['philo-card-header']}>
              <h2>Find Us on Campus</h2>
              <div className={contactStyles['philo-card-decoration']}></div>
            </div>
            <div className={contactStyles['philo-map-container']}>
              <div className={contactStyles['philo-map-overlay']}></div>
              <iframe
                title="Department Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.890292185861!2d-122.167200784687!3d37.77492997975938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fbb2a678bea9d%3A0x29cdf01a44fc687f!2sStanford%20University!5e0!3m2!1sen!2sus!4v1659991234567!5m2!1sen!2sus"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
              <div className={contactStyles['philo-map-notes']}>
                <p>
                  <strong>Parking:</strong> Visitor parking in Lot A & B. Philosophy Hall is building #15.
                </p>
                <p>
                  <strong>Transit:</strong> Blue Line to University Station, 5-min walk.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

  
    </div>
  );
};

export default Contact;
